import portsApi from '../framework/ports/portsApi';

const messageEvents = {
  publishEvent: (data: object): void => {
    portsApi.invoke('MessageBus.publishEvent', [data]);
  },
  publishSticky: (data: object): void => {
    portsApi.invoke('MessageBus.publishSticky', [data]);
  },
  onSubscribe: (
    callback: ({ message, payload }: { message: string; payload: any }) => void,
    args: string[]
  ) => portsApi.on('MessageBus.onSubscribe', callback, args),
};

export default messageEvents;
